(function () {
    "use strict";

    /**
     * @module facilityMap
     */
    let facilityMap = {};

    /**
     * Initialise all embedded facility maps on a particular page
     *
     * @memberof module:facilityMap
     */
    facilityMap.init = function () {
        let mapEmbedFacilities = QLD.utils.listToArray(document.querySelectorAll(".js-map-embed-facility"));

        setTimeout(function () {
            mapEmbedFacilities.forEach(function (mapEmbedFacility) {
                let multiMarkers = [];
                let coords = mapEmbedFacility.dataset.coordinates;
                let iconUrl = mapEmbedFacility.dataset.iconUrl;
                let zoom = mapEmbedFacility.dataset.zoom;
                let popupTitle = mapEmbedFacility.dataset.popupTitle;
                let popupDescription = mapEmbedFacility.dataset.popupDescription;
                let popupDirections = "";
                let popupContent = "";

                // ** Fix: Prevent duplicate initialization **
                let container = L.DomUtil.get(mapEmbedFacility);
                if (container.querySelector(".leaflet-pane.leaflet-map-pane")) {
                    return; // If map already exists, skip initialization
                }

                let map = L.map(mapEmbedFacility);
                let popupOnLoad = mapEmbedFacility.dataset.popup;

                if (mapEmbedFacility.closest(".qld__service_contact-details__map__item")) {
                    if (mapEmbedFacility.closest(".qld__service_contact-details__map__item").querySelectorAll(".js-map-embed-facility__marker-details").length > 0) {
                        multiMarkers = QLD.utils.listToArray(mapEmbedFacility.closest(".qld__service_contact-details__map__item").querySelectorAll(".js-map-embed-facility__marker-details"));
                    }
                }

                if (multiMarkers.length > 0) {
                    multiMarkers.forEach(function (singleMarker, index) {
                        popupDirections = `<div class="leaflet-popup-content-directions">
                                                <a href="${singleMarker.dataset.popupDirections}"><i class="fal fa-directions"></i>Get directions</a>
                                            </div>`;

                        popupContent = `<div class='leaflet-popup-content-details'>
                                            <h4>${singleMarker.dataset.popupTitle}</h4>
                                            <p>${singleMarker.dataset.popupDescription}</p>
                                        </div>
                                        ${popupDirections}`;

                        let icon = L.icon({
                            iconUrl: singleMarker.dataset.iconUrl ? singleMarker.dataset.iconUrl : iconUrl,
                            iconSize: [50, 50],
                            iconAnchor: [25, 50],
                        });

                        let popup = L.popup({
                            className: "qld_facility_tooltip",
                            closeButton: false,
                            closeOnClick: false,
                            autoClose: true,
                            offset: [180, 100],
                        }).setContent(popupContent);

                        coords = singleMarker.dataset.coordinates;
                        if (!coords || typeof coords !== "string") {
                            return;
                        }
                        let coordArray = coords.split(";");

                        if (coordArray.length !== 2) {
                            return;
                        }

                        if (index === 0) {
                            map.setView(coordArray, parseInt(zoom));

                            let marker = new L.marker(coordArray, {
                                icon: icon,
                                alt: `Map marker for ${popupTitle}`,
                            })
                                .addTo(map)
                                .bindPopup(popup);

                            if (popupOnLoad === "true") {
                                marker.openPopup();
                            }
                        } else {
                            let marker = new L.marker(coordArray, {
                                icon: icon,
                                alt: `Map marker for ${popupTitle}`,
                            })
                                .addTo(map)
                                .bindPopup(popup);
                        }
                    });
                } else {
                    if (mapEmbedFacility.dataset.popupDirections) {
                        popupDirections = `<div class="leaflet-popup-content-directions">
                                                <a href="${mapEmbedFacility.dataset.popupDirections}"><i class="fal fa-directions"></i>Get directions</a>
                                            </div>`;
                    }

                    popupContent = `<div class='leaflet-popup-content-details'>
                                        <h4>${popupTitle}</h4>
                                        <p>${popupDescription}</p>
                                    </div>
                                    ${popupDirections}`;

                    let icon = L.icon({
                        iconUrl: iconUrl,
                        iconSize: [50, 50],
                        iconAnchor: [25, 50],
                    });

                    if (!coords || typeof coords !== "string") {
                        return;
                    }
                    let coordArray = coords.split(";");

                    if (coordArray.length !== 2) {
                        return;
                    }

                    map.setView(coordArray, parseInt(zoom));

                    let popup = L.popup({
                        className: "qld_facility_tooltip",
                        closeButton: false,
                        closeOnClick: true,
                        keepInView: true,
                        offset: [180, 100],
                    })
                        .setLatLng(coordArray)
                        .setContent(popupContent)
                        .openOn(map);

                    let marker = new L.marker(coordArray, {
                        icon: icon,
                        alt: `Map marker for ${popupTitle}`,
                    })
                        .addTo(map)
                        .bindPopup(popup);
                }

                L.esri.Vector.vectorBasemapLayer("ArcGIS:Topographic", {
                    apiKey: "AAPK14c2db245cb5432da99353b71b6433dflik7DtfBuaNdb8nB-MjrF9DiaBOQkhlWuu0asMWlyHxAitjLsCJRPXPBU5blMVGr",
                }).addTo(map);

                setInterval(function () {
                    map.invalidateSize();
                }, 400);
            });
        }, 100);
    };

    QLD.facilityMap = facilityMap;

    document.addEventListener("DOMContentLoaded", QLD.facilityMap.init);
})();
